import VueI18n from 'vue-i18n';
import en from './en.json';  
import gr from './gr.json';    
import Vue from 'vue'
import { getLanguage } from '../utils/language-utils';

Vue.use(VueI18n);
const savedLanguage = getLanguage() || 'en';


const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
      en,
      gr
  },
});


export default i18n;